import React from "react";
import type { ApolloClient } from "@apollo/client";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { push } from "store/actions/router";
import { Card } from "react-bootstrap";
import Alert from "components/Alert";

import Button from "components/Button";
import queryString from "query-string";
import { scrollToTop } from "utils/dom";

import { optOut } from "actions/userActions";
import { createErrorSelector } from "store/selectors";
import { userConstants } from "actions/types";
import type { RootState } from "types/state";

const actions = [userConstants.OPT_OUT];

const errorSelector = createErrorSelector(actions);

const mapStateToProps = (state: RootState) => {
  return {
    error: errorSelector(state),
  };
};

const mapDispatchToProps = {
  push,
  optOut,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = WithApolloClient<PropsFromRedux>;

interface State {
  urlHadInviteId: boolean;
  invitationCode: string;
  inviteId: string;
  optedOut: boolean;
}

class IndividualOptOut extends React.Component<Props, State> {
  _isMounted = false;

  constructor(props: Props) {
    super(props);

    const invitationCode = queryString.parse(
      window.location.search
    ).invitationCode;

    const inviteId = queryString.parse(window.location.search).inviteId;

    this.state = {
      urlHadInviteId: !!inviteId,
      invitationCode: (invitationCode as string) || "",
      inviteId: (inviteId as string) || "",
      optedOut: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    scrollToTop();
    if (!this.state.optedOut && this.state.urlHadInviteId) {
      void this.props
        .optOut(
          this.props.client as ApolloClient<object>,
          this.state.inviteId,
          true
        )
        .then(() => {
          if (!this.props.error) {
            this.setState({
              optedOut: true,
            });
          }
        });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <Card className="opt-out-container">
        <Card.Body>
          <img className="door-img" src="/assets/door.png" />
          <Card.Title>
            You{"'ve"} successfully opted out of the Icon Savings retirement
            plan.
          </Card.Title>
          <p className="sub-text">
            You can opt back in at anytime. If you would like to do so now,
            click the button below and create an account.
          </p>
          <Button
            name="action"
            onClick={() => {
              void this.props
                .optOut(
                  this.props.client as ApolloClient<object>,
                  this.state.inviteId,
                  false
                )
                .then(() => {
                  this.setState({
                    optedOut: false,
                  });
                });
              this.props.push(
                `/?inviteId=${this.state.inviteId}&invitationCode=${this.state.invitationCode}`
              );
            }}
            btnLabel="Opt In?"
          />
          {this.props.error && <Alert type="error" msg={this.props.error} />}
        </Card.Body>
        <div></div>
      </Card>
    );
  }
}

export default connector(withApollo<Props>(IndividualOptOut));
